import { render, staticRenderFns } from "./KidsPrivacy_202609.vue?vue&type=template&id=b325984e&scoped=true"
import script from "./KidsPrivacy_202609.vue?vue&type=script&lang=js"
export * from "./KidsPrivacy_202609.vue?vue&type=script&lang=js"
import style0 from "@/assets/help/document.css?vue&type=style&index=0&id=b325984e&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b325984e",
  null
  
)

export default component.exports